<template>
  <b-container fluid>
    <h2>Docparser</h2>

    <b-nav>
      <b-nav-item
        :to="{ name: 'docparser-parsings-list', params: { type: 'new' } }"
        :active="type == 'new'"
      >
        Nieuw
      </b-nav-item>
      <!-- <b-nav-item 
        :to="{ name: 'docparser-parsings-list', params: { type: 'processed' } }"
        :active="type == 'processed'"
      >Verwerkt</b-nav-item> -->
      <b-nav-item 
        :to="{ name: 'docparser-upload' }"
      >
        Upload naar docparser
      </b-nav-item>
    </b-nav>
    <b-table
      :items="parsings"
      :caption="parsings.length + ' ' + type + ' documenten'"
      :show-empty="parsings.length ==0"
      :busy="busy"
      :fields="[
        'Status',
        { key: 'GemaaktOp', label: 'Datum' },
        { key: 'IsGoedgekeurd', label: 'Uitslag', tdClass: tdClass },
        'Keuringsdatum',
        'Bestandsnaam',
        'Regels',
        'Endpoint',
      ]"
      bordered
      caption-top
      striped
      small
      select-mode="single"
      selectable
      empty-text="Geen documenten"
      hover
      dark
      @row-clicked="(row) => {
        $router.push({
          name: 'docparser-parsing',
          params: { id: row.ID },
        });
      }"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle mx-2" />
          <strong>Ophalen...</strong>
        </div>
      </template>
      <template #cell(GemaaktOp)="row">
        {{
          moment(row.item.GemaaktOp).format("lll")
        }}
      </template>
      <template #cell(Keuringsdatum)="row">
        {{
          row.item.ParsedPayload.keuringsdatum ? moment(row.item.ParsedPayload.keuringsdatum.formatted).format("LL") : 'Geen'
        }}
      </template>
      <tempate #cell(IsGoedgekeurd)="row">
        {{ row.item.Status }} test
      </tempate>
      <template #cell(Bestandsnaam)="row">
        {{ row.item.ParsedPayload.file_name }}

        <b-badge 
          v-if="row.item.ParsedPayload.file_name.substr(row.item.ParsedPayload.file_name.length - 3).toLowerCase() !== 'pdf'" 
          variant="warning"
        >
          Geen PDF!
        </b-badge>
      </template>
    </b-table>
  </b-container>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";

export default {
  name: "Parsed",
  mixins: [serviceMixin],
  beforeRouteUpdate (to, from, next) {
    if (to.params.type != from.params.type) this.getParsings(to.params.type);
    next();
  },
  props: {
    type: {
      type: String,
      default: "new",
    }
  },
  data() {
    return {
      parsings: [],
      busy: false,
     
    };
  },
  mounted() {
    this.getParsings(this.$route.params.type);
  },

  methods: {
    tdClass(td) {
      console.log(td);
      // if (td.toLowerCase().includes('met opmerkingen')) return 'table-warning';
      if (td.toLowerCase().includes('goedgekeurd')) return 'table-success text-dark';
      if (td.toLowerCase().includes('afgekeurd')) return 'table-danger text-dark';
      return 'table-warning text-dark';
    },
    getParsings(type) {
      var vm = this;
      this.busy= true;
      this.parsings = [];
      this.get(`/docparser/parsings/${type}`)
        .then(function (response) {
          console.log(response.data);
          vm.parsings = response.data.result.reverse();
        })
        .catch(function (error) {
          console.log("error");
          console.log(error);
        })
        .finally(function() {
          vm.busy = false
        });
    },
  },
};
</script>